/**
 * OpentokRecording MediaStream implementation.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


/**
 * @implements {IMediaStream}
 */
export default class MediaStream {
    /**
     * @param {MediaStream} gumStream GUM stream
     * @param {Array.<IMediaStreamTrack>} tracks Stream tracks
     */
    constructor(gumStream, tracks) {
        this.gumStream = gumStream;
        this.tracks = tracks;
    }

    /**
     * @return {Promise.<Array.<IMediaStreamTrack>>}
     */
    getTracks() {
        return Promise.resolve(this.tracks);
    }

    /**
     * @return {MediaStream}
     */
    getGUMStream() {
        return this.gumStream;
    }

    /**
     * Stop streaming
     *
     * @return {Promise.<*>}
     */
    stop() {
        this.gumStream.getAudioTracks().forEach((track) => {
            track.stop();
        });

        this.gumStream.getVideoTracks().forEach((track) => {
            track.stop();
        });

        return Promise.resolve();
    }

    /**
     * releases resources
     * @return {Promise}
     */
    dispose() {
        return Promise.all(this.tracks.map(t => t.dispose()));
    }
}
